import { User } from '@/models/User';

export const isUserProfileIncomplete = (user: User): boolean =>
  !user.firstName || !user.lastName || !user.isProfileComplete;
